var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNfrLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__a",
    cx: "50%",
    cy: "50%",
    r: "87.656%",
    fx: "50%",
    fy: "50%",
    gradientTransform: "matrix(-.73684 0 0 -1 .868 1)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#50C3C8",
    stopOpacity: 0.796
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5f00a0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.143,
    height: 20,
    x: 0.357,
    fill: "url(#prefix__a)",
    rx: 1.429
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#5f00a0",
    strokeWidth: 0.5,
    d: "M5.345 9.39v5.146H3.433V5.91h1.8l3.245 5.168V5.911h1.9v8.625h-1.8L5.345 9.389zm8.146 1.703v3.443H11.58V5.91h5.661v1.638h-3.75v1.916h3.27v1.628h-3.27zm7.483.312h-1.172v3.13H17.89V5.912h3.107c.991 0 1.77.226 2.33.687.57.471.855 1.15.855 2.018 0 .593-.145 1.099-.44 1.51-.24.337-.56.609-.954.814l1.7 3.155.03.118v.323h-1.915l-1.63-3.13zm-1.172-1.633h1.2c.42 0 .732-.1.95-.296.213-.19.319-.45.319-.799 0-.37-.1-.642-.295-.83-.196-.189-.505-.291-.934-.298h-1.24v2.223z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNfrLogo);
export default __webpack_public_path__ + "static/media/nfr_logo.68ce5c3550461f984ae3969b8c6deb29.svg";
export { ForwardRef as ReactComponent };